import { useMatch, useNavigate } from "react-router-dom";
import { list3RoutesCombined } from "./ListAndDetailSamplesMultipleListsNavigation";
import { PageDefaultSegment, isMobileView } from "@sis/react-library";
import { list3Data } from "./ListItemDto";
import { ListAndDetailSamplesMultipleListHeadingContainer } from "./ListAndDetailSamplesMultipleListHeadingContainer";
import { Box, Button } from "@mui/material";
import { getMatch } from "./listAndDetailSamplesMultipleListFunctions";

export const ListAndDetailSamplesMultipleList3EditPage = () => {

  const navigate = useNavigate();
  const isMobile = isMobileView();

  const matchEdit = useMatch(list3RoutesCombined().list_editMatch);
  const matchNew = useMatch(list3RoutesCombined().new);

  const match = getMatch([matchEdit, matchNew]);
  const code1 = match?.params.code1;
  const code2 = match?.params.code2;
  const code3 = match?.params.code3;

  const list3Item = list3Data.find((l1) => l1.code3 === code3);

  const handleClose = () => {
    navigate(list3RoutesCombined(code1, code2).list);
  }

  return (
    <ListAndDetailSamplesMultipleListHeadingContainer
      widthOffset={14}
      heading={
        <Box>
          <b>{list3Item ? `Edit item: ${list3Item.description}` : 'New item'}</b>
        </Box>
      }
    >
      <Box sx={{
        paddingTop: isMobile ? '20px' : '52px'
      }}
      >
        <PageDefaultSegment textAlign='center'>
          <Box>{list3Item ? 'Edit this item' : 'New item'}</Box>
          <Box>
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{ height: '24px' }}
            >
              Close
            </Button>
          </Box>
        </PageDefaultSegment>
      </Box>
    </ListAndDetailSamplesMultipleListHeadingContainer>
  )
}
